import baseApi from "shared/networking/baseApi";
import {getMeta} from "./tools";

export async function createTicket(
    quoteRequest,
    product,
    premium,
    lengthOfCoverage,
    showClientView = true,
) {
    const response = await baseApi.post('api/tickets/', {
        showClientView,
        quoteRequest,
        product,
        premium: premium && premium.amount,
        premiumFrequency: premium && premium.period,
        lengthOfCoverage,
        agencyName: getMeta("agencyName"),
    });

    return response.data;
}

export async function getTicket(token) {
    if (!token) {
        throw new Error('No share token');
    }

    const response = await baseApi.get(`api/tickets/${token}`);

    return response.data;
}

export async function saveTicket(token, data) {
    if (!token) {
        throw new Error('No share token');
    }

    const response = await baseApi.put(`api/tickets/${token}`, data);

    return response.data;
}

export async function getShareLink(token, sendToClient, sendToAgent) {
    if (!token) {
        throw new Error('No share token');
    }

    const response = await baseApi.post(`api/tickets/${token}/share`, {sendToClient, sendToAgent});

    return response.data;
}
